window.theme.component('modal', () => {

    // Return if is in admin to prevent the block from breaking.
    if (typeof initializer !== 'undefined' && initializer.isAdmin) return;

    function getModal(target) {
        if (typeof target === 'string') {
            return document.querySelector(target) || document.querySelector('[data-modal-id="' + target + '"]');
        } else if (target instanceof HTMLElement) {
            return target;
        } else {
            return document.querySelector('.js-modal.is-active');
        }
    }

    /**
     * Open the modal.
     */
    function open(target) {
        const modal = getModal(target);

        if (modal) {
            const event = new CustomEvent('beforeopen', { detail: modal });

            modal.dispatchEvent(event);

            if (!event.defaultPrevented) {
                modal.classList.add('is-active');

                const video = modal.querySelector('video, iframe');

                if (video) {
                    if (video.tagName === 'VIDEO') {
                        video.play();
                    } else if (video.tagName === 'IFRAME' && video.getAttribute('id') !== 'pdf-iframe') {
                        const videoUrl = new URL(video.dataset.src);
                        videoUrl.searchParams.set('autoplay', 1);

                        video.src = videoUrl;
                    }
                }

                modal.dispatchEvent(new CustomEvent('open', { detail: modal }));
            }
        }
    }
    window.theme.components.modal.open = open;

    /**
     * Close the modal.
     */
    function close(target) {
        const modal = getModal(target);

        if (modal) {
            modal.classList.remove('is-active');

            const video = modal.querySelector('video');

            if (video) {
                video.pause();
            }

            const iframe = modal.querySelector('iframe');

            if (iframe) {
                iframe.src = '';
            }

            modal.dispatchEvent(new CustomEvent('close', { detail: modal }));
        }
    }
    window.theme.components.modal.close = close;

    /**
     * Attach event listeners to modal triggers
     */
    const triggers = document.querySelectorAll('.js-modal-trigger');

    if (triggers) {
        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                const modalId = this.getAttribute('data-modal');

                if (modalId) {
                    window.theme.components.modal.open(modalId);
                }
            });
        });
    }

    /**
     * Attach event listeners to modal close buttons
     */
    const closeButtons = document.querySelectorAll('.js-modal-close');

    if (closeButtons) {
        closeButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                const modal = this.closest('.js-modal');

                if (modal) {
                    close(modal);
                }
            });
        });
    }
});